
class AnimationExHero {

	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleExHero = this.sectionsContainer.querySelectorAll('.section-ex-hero');
		
		if (!this.$moduleExHero.length)
			return;
		
		this.$moduleExHeroElements = [];

		this.$moduleExHero.forEach(module => {
			this.$moduleExHeroElements.push(module.querySelectorAll('.anima'));
		});

		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleExHero.forEach((module, index) => {
			gsap.set(module, { opacity: 1 });
			gsap.set(this.$moduleExHeroElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleExHero = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleExHero[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleExHeroElements[index], { clearProps: true });
			}
        });
    
        this.moduleExHero.addLabel('step1');
        this.moduleExHero.to(this.$moduleExHero[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleExHero.to(this.$moduleExHeroElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}

export default AnimationExHero;
